import { HelpFeature } from '@/model/HelpModel';
import React from 'react';
import { EventsIcon, HeaderTitleBar, HelpFactoryComponent } from '../../components/common';
import { EventTable } from '../../components/event/';
import styles from './event.module.scss';

const topicId = 'Events';

const EventPage: React.FC = () => {
	return (
		<>
			<HeaderTitleBar
				title={_('EventViewer')}
				icon={<EventsIcon />}
				helpButton={<HelpFactoryComponent helpFeature={HelpFeature.Events} isLight={true} topicId={topicId} className={styles.helpButton} />}
			/>
			<div className={styles.eventTablePage}>
				<EventTable />
			</div>
		</>
	);
};

export { EventPage };
